import { fetchOilList } from "components/oilList/redux/dispatcher";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Spinner,
  Alert,
  Row,
  Col,
  FormFeedback,
  Tooltip,
} from "reactstrap";
import { createMachine, fetchMachineList } from "./redux/dispatcher";
import { fetchCompanyList } from "components/companyList/redux/dispatcher";
import { fetchFluidHandlerList } from "commonRedux/getFluidHandler/dispatcher";
import { fetchOilByCompanyId } from "commonRedux/getOilByCompanyId/dispatcher";
import { errorOilByCompany } from "commonRedux/getOilByCompanyId/action";
import ButtonWithToopltip from "../../commonComponents/ButtonWithTooltip";
import toast from "react-hot-toast";

function AddMachine({ args }) {
  const oilList = useSelector((state) => state.oilListByCompanyReducer) || [];
  const companyListData =
    useSelector((state) => state?.companyListReducer) || [];
  const fluidHandlerData =
    useSelector((state) => state?.fluidHandlerReducer) || [];

  const dispatch = useDispatch();
  const [loginUserType, setLoginUserType] = useState(
    useSelector((state) => state.authReducer).data?.user?.role
  );
  const [machineName, setMachineName] = useState("");
  const [machineModel, setMachineModel] = useState("");
  const [machineSize, setMachineSize] = useState("");
  const [machineNumber, setMachineNumber] = useState("");
  const [tankSize, setTankSize] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [currentUser, setCurrentUser] = useState("");
  const [companyList, setcompanyList] = useState(
    companyListData?.data?.data || []
  );
  const [userList, setUserList] = useState(
    fluidHandlerData?.fluidHandlerList?.result || []
  );
  const [concentrationParameters, setConcentrationParameters] =
    useState("lower");
  const [modal, setModal] = useState(false);
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(oilList?.isLoading);
  const [error, setError] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [coolantList, setCoolantList] = useState([]);
  const [coolant, setCoolant] = useState();
  const [maintanceOilList, setMaintanceOilList] = useState([]);
  const [maintanceOil, setMaintanceOil] = useState();
  const [hydraulicOilList, setHydraulicOilList] = useState([]);
  const [hydraulicOil, setHydraulicOil] = useState();
  const [searchData, setSearchData] = useState("");
  const [filteredUser, setFilteredUser] = useState(userList);
  const [errorMessage, setErrorMessage] = useState("");
  const [formError, setFormError] = useState({
    machineName: false,
    model: false,
    machineSize: false,
    machineNumber: false,
    maintanceOil: false, //optional
    hydraulicOil: false, //optional
    coolantOil: false,
    tankSize: false,
    selectedCompany: false,
    selectedUsers: false,
    lowerCp: false,
    higherCp: false,
    oilTopupRatio: false,
    waterUsed: false,
  });
  const [lowerCP, setLowerCP] = useState("");
  const [higherCP, setHigherCP] = useState("");
  const [perCentageOilTopRatio, setPercentageOilTopRatio] = useState("");
  const [waterUsed, setWeaterUsed] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    setCompanyName(companyList[0]?.id);
  }, [companyList]);

  useEffect(() => {
    setcompanyList(companyListData?.data?.data || []);
  }, [companyListData]);
  useEffect(() => {
    dispatch(fetchCompanyList());
    dispatch(fetchFluidHandlerList());
  }, [dispatch]);

  useEffect(() => {
    if (companyName) {
      dispatch(fetchOilByCompanyId(companyName));
    } else {
      dispatch(errorOilByCompany(""));
    }
  }, [companyName]);
  useEffect(() => {
    setUserList(fluidHandlerData?.fluidHandlerList?.result || []);
    setFilteredUser(fluidHandlerData?.fluidHandlerList?.result || []);
  }, [fluidHandlerData]);

  useEffect(() => {
    if (oilList?.oilByCompany) {
      const coolants = oilList.oilByCompany.filter(
        (oil) => oil?.oil_type === "Coolant"
      );
      const maintenanceOils = oilList.oilByCompany.filter(
        (oil) => oil?.oil_type === "Maintenance"
      );
      const hydraulicOils = oilList.oilByCompany.filter(
        (oil) => oil?.oil_type === "Hydraulic"
      );

      setCoolantList(coolants);
      setMaintanceOilList(maintenanceOils);
      setHydraulicOilList(hydraulicOils);
    } else {
      // setCoolantList([]);
      // setMaintanceOilList([]);
      // setHydraulicOilList([]);
    }
  }, [oilList]);

  // Handle Modal (Show or not)
  const toggleModal = () => {
    setModal(!modal);
    setError("");
    setLoading(false);
    setMachineName("");
    setMachineModel("");
    setCurrentUser("");
    setMachineSize("");
    setTankSize("");
    setCompanyName("");
    setMachineNumber("");
    setConcentrationParameters("lower");
    setError("");
    setWeaterUsed("");
    setSelectedUsers([]);
    setPercentageOilTopRatio("");
    setLowerCP("");
    setHigherCP("");
    setCoolant("");
    setFormError({
      machineName: false,
      model: false,
      machineSize: false,
      machineNumber: false,
      maintanceOil: false, //optional
      hydraulicOil: false, //optional
      coolantOil: false,
      tankSize: false,
      selectedCompany: false,
      selectedUsers: false,
      lowerCp: false,
      higherCp: false,
      oilTopupRatio: false,
      waterUsed: false,
    });
  };

  const handleStatusChange = () => setStatus(!status);

  // Handle Form
  const handleFormSubmit = async (e) => {
    console.log("hanldeSubmit");
    e.preventDefault();
    if (
      !machineName ||
      !machineModel ||
      !machineSize ||
      !tankSize ||
      !machineNumber ||
      !companyName ||
      !perCentageOilTopRatio ||
      !lowerCP ||
      !higherCP ||
      !waterUsed ||
      selectedUsers.length === 0 ||
      !coolant
    ) {
      console.log("form Error");
      setFormError({
        machineName: formError.machineName || !machineName,
        model: formError.model || !machineModel,
        machineSize: formError.machineSize || !machineSize,
        machineNumber: formError.machineNumber || !machineNumber,
        maintanceOil: formError.maintanceOil, //optional
        hydraulicOil: formError.hydraulicOil, //optional
        coolantOil: formError.coolantOil || !coolant,
        tankSize: formError.tankSize || !tankSize,
        selectedCompany: formError.selectedCompany || !companyName,
        selectedUsers: formError.selectedUsers || selectedUsers.length === 0,
        lowerCp: formError.lowerCp || !lowerCP,
        higherCp: formError.higherCp || !higherCP,
        oilTopupRatio: formError.oilTopupRatio || !perCentageOilTopRatio,
        waterUsed: formError.waterUsed || !waterUsed,
      });
      setErrorMessage("Please correct the errors in the form.");
      if (formError.selectedUsers) {
        toast.error("Please select a user")
      }
      return;
    }
    setErrorMessage("");
    setError("");
    try {
      const machineData = {
        name: machineName,
        model: machineModel,
        size: machineSize,
        tank_size: tankSize,
        machine_number: machineNumber,
        company: companyName,
        oil_topup_ratio: perCentageOilTopRatio,
        conc_limit_lower: lowerCP,
        conc_limit_higher: higherCP,
        water: waterUsed,
        users: selectedUsers,
        coolant_oil: coolant,
        ...(maintanceOil && { maintenance_oil: maintanceOil }),
        ...(hydraulicOil && { hydraulic_oil: hydraulicOil }),
        status: status ? "active" : "inactive",
      };
      dispatch(createMachine(machineData, toggleModal));
    } catch (err) {
      setError("Error adding machine. Please try again.");
    } finally {
      // toggleModal();
      console.log("Adding machien Click");
    }
  };

  const handleConcentrationChange = (value) => {
    setConcentrationParameters(value);
  };

  const handleUserSelection = (e) => {
    const value = e.target.value;
    setSelectedUsers((prevState) =>
      prevState.includes(value)
        ? prevState.filter((item) => item !== value)
        : [...prevState, value]
    );
  };
  const handleUserSearch = (e) => {
    const value = e.target.value;
    setSearchData(value);

    const filteredData = userList.filter((item) =>
      item?.first_name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredUser(filteredData);
  };
  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  };
  //Regex
  const validateMachineName = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, machineName: false }));
      return;
    }
    const regex = /^.{2,20}$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, machineName: !isValid }));
  };

  const validateMachineSize = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, machineSize: false }));
      return;
    }
    const regex = /^.{2,15}$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, machineSize: !isValid }));
  };

  const validateMachineNumber = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, machineNumber: false }));
      return;
    }
    const regex = /^.{1,15}$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, machineNumber: !isValid }));
  };

  const validateTankSize = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, tankSize: false }));
      return;
    }
    const regex = /^.{2,15}$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, tankSize: !isValid }));
  };
  const validateModel = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, model: false }));
      return;
    }
    const regex = /^.{2,15}$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, model: !isValid }));
  };

  const validateLowerCP = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, lowerCp: false }));
      return;
    }
    // Prevent input if more than 2 digits
    if (value.length > 2) {
      e.target.value = value.slice(0, 2);
      setLowerCP(value.slice(0, 2));
      return;
    }
    const regex = /^\d{1,2}$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, lowerCp: !isValid }));
  };

  const validateHigherCP = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, higherCp: false }));
      return;
    }
    // Prevent input if more than 2 digits
    if (value.length > 2) {
      e.target.value = value.slice(0, 2);
      setHigherCP(value.slice(0, 2));
      return;
    }
    const regex = /^\d{1,2}$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, higherCp: !isValid }));
  };

  const validatePerCentageOilTopRatio = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, oilTopupRatio: false }));
      return;
    }
    const regex = /^\d{1,10}(\.\d{1,})?$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, oilTopupRatio: !isValid }));
  };

  const validateWaterUsed = (e) => {
    const value = e.target.value;
    if (!value) {
      setError(false);
      setFormError((prevState) => ({ ...prevState, waterUsed: false }));
      return;
    }
    const regex = /^\d{1,10}(\.\d{1,})?$/;
    const isValid = regex.test(value);

    setError(!isValid);
    setFormError((prevState) => ({ ...prevState, waterUsed: !isValid }));
  };
  return (
    <div>
      <ButtonWithToopltip
        icon={"fa-plus"}
        onClickAction={toggleModal}
        tooltipLabel="Add Machine"
        targetId="addMachineId"
      />

      <Modal
        isOpen={modal}
        toggle={toggleModal}
        {...args}
        modalClassName="custom-modal"
      >
        <h1
          style={{
            textAlign: "center",
            borderBottom: "4px solid rgb(14, 61, 13)",
            color: "rgb(14, 61, 13)",
          }}
          className=" m-3"
        >
          Add Machine
        </h1>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="machineName">
                    Machine Name<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    id="machineName"
                    name="machineName"
                    placeholder="Enter Machine Name"
                    type="text"
                    value={machineName}
                    invalid={formError.machineName}
                    onChange={(e) => {
                      setMachineName(e.target.value);
                      validateMachineName(e);
                    }}
                    maxLength={20}
                  />
                  <FormFeedback>
                    Machine Name must only contain alphabets.
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="machineModel">
                    Model/Cell<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    id="machineModel"
                    name="machineModel"
                    placeholder="Enter Machine Model"
                    type="text"
                    value={machineModel}
                    invalid={formError.model}
                    onChange={(e) => {
                      setMachineModel(e.target.value);
                      validateModel(e);
                    }}
                    maxLength={15}
                  />
                  <FormFeedback>
                    Model must only contain alphabets.
                  </FormFeedback>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="machineSize">
                    Machine Size/Line No<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    id="machineSize"
                    name="machineSize"
                    placeholder="Enter Machine Size"
                    type="text"
                    value={machineSize}
                    invalid={formError.machineSize}
                    onChange={(e) => {
                      setMachineSize(e.target.value);
                      validateMachineSize(e);
                    }}
                    maxLength={15}
                  />
                  <FormFeedback>
                    Machine Size must contain only letters and numbers, colons,
                    or commas are not allowed.
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="machineNumber">
                    Machine Number<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    id="machineNumber"
                    name="machineNumber"
                    type="text"
                    placeholder="Enter machine number (Should be unique)"
                    value={machineNumber}
                    invalid={formError.machineNumber}
                    onChange={(e) => {
                      setMachineNumber(e.target.value);
                      validateMachineNumber(e);
                    }}
                    maxLength={15}
                  />
                  <FormFeedback>
                    Machine Number must contain only letters and numbers.
                  </FormFeedback>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              {/* {loginUserType === 'company_admin' && ( */}
              <>
                <Col md={6}>
                  <FormGroup>
                    <Label for="companySelect">
                      Select Company<span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="select"
                      name="selectCompany"
                      id="companySelect"
                      value={companyName}
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                        setFormError((prevState) => ({
                          ...prevState,
                          selectedCompany: false,
                        }));
                      }}
                      invalid={formError.selectedCompany}
                    >
                      <option value={""}>Select company</option>
                      {companyList.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.company_name}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback>Select a company.</FormFeedback>
                  </FormGroup>
                </Col>
              </>
              {/* )} */}

              {/* {loginUserType === 'super_admin' || loginUserType === 'enterprise_admin' ? (
    <>
        <Col md={6}>
            <FormGroup>
                <Label for="companySelect">Select Company*</Label>
                <Input
                    type="select"
                    name="selectCompany"
                    id="companySelect"
                    value={companyName}
                    onChange={(e) => {
                        setCompanyName(e.target.value)
                        setFormError(prevState => ({ ...prevState, selectedCompany: false }));
                    }}
                    invalid={formError.selectedCompany}
                >
                    {companyList.map((item) => (
                        <option key={item?.id} value={item?.id}>{item?.company_name}</option>
                    ))}
                </Input>
                <FormFeedback>Select a company.</FormFeedback>
            </FormGroup>
        </Col>
    </>
) : ''} */}

              {/* {loginUserType === 'super_admin' && (
    <>
        <Col md={6}>
            <FormGroup>
                <Label for="companySelect">Select Company*</Label>
                <Input
                    type="select"
                    name="selectCompany"
                    id="companySelect"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                >
                    <option value="">Select company</option>
                    {companyList.map((item) => (
                        <option key={item?.id} value={item?.id}>{item?.company_name}</option>
                    ))}
                </Input>
            </FormGroup>
        </Col>
    </>
)} */}

              {/* {loginUserType === 'enterprise_admin' && (
    <>
        <Col md={6}>
            <FormGroup>
                <Label for="companySelect">Select Company*</Label>
                <Input
                    type="select"
                    name="selectCompany"
                    id="companySelect"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                >
                    <option value="">Select company</option>
                    {companyList.map((item) => (
                        <option key={item?.id} value={item?.id}>{item?.company_name}</option>
                    ))}
                </Input>
            </FormGroup>
        </Col>
    </>
)} */}

              <Col md={6}>
                <FormGroup>
                  <Label for="coolant">
                    Select Coolant<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="select"
                    name="coolant"
                    id="coolant"
                    value={coolant}
                    invalid={formError.coolantOil}
                    onChange={(e) => {
                      setCoolant(e.target.value);
                      setFormError((prevState) => ({
                        ...prevState,
                        coolantOil: false,
                      }));
                    }}
                  >
                    <option value="">Select Coolant</option>
                    {coolantList.map((item) => (
                      <option key={item?.oil_id} value={item?.oil_id}>
                        {item?.brand_name} ({item?.product_name})
                      </option>
                    ))}
                  </Input>
                  <FormFeedback>Select coolant oil.</FormFeedback>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="maintanceoil">Select Neat Oil</Label>
                  <Input
                    type="select"
                    name="maintanceoil"
                    id="maintanceoil"
                    value={maintanceOil}
                    invalid={formError.maintanceOil}
                    onChange={(e) => {
                      setMaintanceOil(e.target.value);
                      setFormError((prevState) => ({
                        ...prevState,
                        maintanceOil: false,
                      }));
                    }}
                  >
                    <option value="">Select Neat Oil</option>
                    {maintanceOilList.map((item) => (
                      <option key={item?.oil_id} value={item?.oil_id}>
                        {item?.brand_name} ({item?.product_name})
                      </option>
                    ))}
                  </Input>
                  <FormFeedback>Select maintance oil.</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="Hydraulicoil">Select Hydraulic Oil</Label>
                  <Input
                    type="select"
                    name="Hydraulicoil"
                    id="Hydraulicoil"
                    value={hydraulicOil}
                    invalid={formError.hydraulicOil}
                    onChange={(e) => {
                      setHydraulicOil(e.target.value);
                      setFormError((prevState) => ({
                        ...prevState,
                        hydraulicOil: false,
                      }));
                    }}
                  >
                    <option value="">Select Hydraulic Oil</option>
                    {hydraulicOilList.map((item) => (
                      <option key={item?.oil_id} value={item?.oil_id}>
                        {item?.brand_name} ({item?.product_name})
                      </option>
                    ))}
                  </Input>
                  <FormFeedback>Select hydraulic oil.</FormFeedback>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="tankSize">
                    Tank Size<span style={{ color: "red" }}>*</span>
                  </Label>

                  <Input
                    id="tankSize"
                    name="tankSize"
                    placeholder="Enter Tank Size"
                    type="number"
                    value={tankSize}
                    invalid={formError.tankSize}
                    onChange={(e) => {
                      setTankSize(e.target.value);
                      validateTankSize(e);
                    }}
                    maxLength={15}
                  />
                  <FormFeedback>
                    TankSize must contain only letters and numbers.
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                {/* <FormGroup>

                                    <Label for="selectuser">Select Users*</Label>
                                    <Input
                                        type="text"
                                        id="searchInput"
                                        value={searchData}
                                        onChange={handleUserSearch}
                                        placeholder="Search user by their name..."
                                        invalid={formError.selectedUsers}
                                    />
                                    <div style={{ maxHeight: '125px', overflowY: 'auto', border: '1px solid #ced4da', padding: '10px' }} className='rounded '>

                                        {filteredUser.map((item) => (
                                            <CustomInput
                                                key={item?.uuid}
                                                type="checkbox"
                                                id={item?.uuid}
                                                label={`${item?.first_name} ${item?.last_name}`}
                                                value={item?.uuid}
                                                checked={selectedUsers.includes(item?.uuid)}
                                                onChange={(e) => {
                                                    handleUserSelection(e)
                                                    setFormError(prevState => ({ ...prevState, selectedUsers: false }));
                                                }}

                                                className='m-1'
                                            />
                                        ))}
                                    </div>
                                    <FormFeedback>Select a user.</FormFeedback>
                                </FormGroup> */}
                <FormGroup>
                  <Label for="selectuser">
                    Select Users<span style={{ color: "red" }}>*</span>
                  </Label>
                  <div
                    onClick={toggleDropdown}
                    style={{
                      cursor: "pointer",
                      border: "1px solid #ced4da",
                      padding: "10px",
                      borderRadius: "4px",
                      position: "relative",
                    }}
                  >
                    {dropdownOpen ? (
                      <React.Fragment>
                        <div className="d-flex justify-content-between ">
                          <span>{"Select Users"} </span>
                          <span>
                            <i class="fa-solid fa-caret-up"></i>
                          </span>
                        </div>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <div className="d-flex justify-content-between ">
                          <span>{"Select Users"} </span>
                          <span>
                            <i class="fa-solid fa-caret-down"></i>
                          </span>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                  {dropdownOpen && (
                    <div
                      style={{
                        maxHeight: "125px",
                        overflowY: "auto",
                        border: "1px solid #ced4da",
                        padding: "10px",
                      }}
                      className="rounded "
                    >
                      {filteredUser.map((item) => (
                        <CustomInput
                          key={item?.uuid}
                          type="checkbox"
                          id={item?.uuid}
                          label={`${item?.first_name} ${item?.last_name}`}
                          value={item?.uuid}
                          // disabled={item?.iseditable}
                          checked={selectedUsers.includes(item?.uuid)}
                          onChange={(e) => {
                            handleUserSelection(e);
                            setFormError((prevState) => ({
                              ...prevState,
                              selectedUsers: false,
                            }));
                          }}
                          className="m-1"
                        />
                      ))}
                    </div>
                  )}
                  {formError.selectedUsers && (
                    <FormFeedback>Select a user.</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                {/* <FormGroup>
                                    <Label for="concentration">Concentration Parameters*</Label>
                                    <div>
                                        <Button
                                            color={concentrationParameters === 'lower' ? 'primary' : 'secondary'}
                                            onClick={() => handleConcentrationChange('lower')}
                                        >
                                            Lower
                                        </Button>
                                        <Button
                                            color={concentrationParameters === 'higher' ? 'primary' : 'secondary'}
                                            onClick={() => handleConcentrationChange('higher')}
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Higher
                                        </Button>
                                    </div>
                                </FormGroup> */}
                <FormGroup>
                  <Label for="lowercp">
                    Lower Concentration Parameter
                    <span style={{ color: "red" }}>*</span>
                  </Label>

                  <Input
                    id="lowercp"
                    name="lowercp"
                    placeholder="Enter Lower Concentration Parameter"
                    type="number"
                    value={lowerCP}
                    invalid={formError.lowerCp}
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      setLowerCP(e.target.value);
                      validateLowerCP(e);
                    }}
                    maxLength={2}
                  />
                  {/* <FormFeedback>
                    Lower Concentration Paramters must contain only letters and
                    numbers.
                  </FormFeedback> */}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="highercp">
                    Higher Concentration Parameter
                    <span style={{ color: "red" }}>*</span>
                  </Label>

                  <Input
                    id="highercp"
                    name="highercp"
                    placeholder="Enter Higher Concentration Parameter"
                    type="number"
                    value={higherCP}
                    invalid={formError.higherCp}
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      setHigherCP(e.target.value);
                      validateHigherCP(e);
                    }}
                    maxLength={2}
                  />
                  {/* <FormFeedback>
                    Higher Concentration Paramters must contain only letters and
                    numbers.
                  </FormFeedback> */}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="potr">
                    Percentage Oil Top-up Ratio
                    <span style={{ color: "red" }}>*</span>
                  </Label>

                  <Input
                    id="potr"
                    name="potr"
                    placeholder="Enter % Oil Top Up Ratio "
                    type="number"
                    value={perCentageOilTopRatio}
                    invalid={formError.oilTopupRatio}
                    onChange={(e) => {
                      setPercentageOilTopRatio(e.target.value);
                      validatePerCentageOilTopRatio(e);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                    maxLength={10}
                  />
                  {/* <FormFeedback>
                    Percentage Oil Top-up Ratio must contain only letters and
                    numbers.
                  </FormFeedback> */}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="waterused">
                    Water Used<span style={{ color: "red" }}>*</span>
                  </Label>

                  <Input
                    id="waterused"
                    name="waterused"
                    placeholder="Enter Water Used Value"
                    type="text"
                    value={waterUsed}
                    invalid={formError.waterUsed}
                    onChange={(e) => {
                      setWeaterUsed(e.target.value);
                      validateWaterUsed(e);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                    maxLength={10}
                  />
                  {/* <FormFeedback>
                    Water Used must contain only letters and numbers.
                  </FormFeedback> */}
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for="statusSelect">Status</Label>
              <CustomInput
                type="switch"
                id="statusSelect"
                name="status"
                label={status ? "Active" : "Inactive"}
                checked={status}
                onChange={handleStatusChange}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-primary" onClick={handleFormSubmit} disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Add Machine"}
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default AddMachine;
